import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollProgress from './components/ScrollProgress';
import FloatingCTA from './components/FloatingCTA';
import HeroSection from './sections/HeroSection';
import ProductRevealSection from './sections/ProductRevealSection';
import CompactServicesSection from './sections/CompactServicesSection';
import AnalyticsSection from './sections/AnalyticsSection';
import AutomationSection from './sections/AutomationSection';
import PlatformSection from './sections/PlatformSection';
import AIAgentSection from './sections/AIAgentSection';
import LiveBudgetsSection from './sections/LiveBudgetsSection';
import BuyBoxSection from './sections/BuyBoxSection';
import KeywordOptimizationSection from './sections/KeywordOptimizationSection';
import EnhancedReportingSection from './sections/EnhancedReportingSection';
import CaseStudiesSection from './sections/CaseStudiesSection';
import TestimonialsSection from './sections/TestimonialsSection';
import CTASection from './sections/CTASection';
import ContactSection from './sections/ContactSection';

function App() {
  return (
    <div className="min-h-screen bg-[#05060B] text-white scrollbar-dark">
      <ScrollProgress />
      <div className="noise-overlay" />
      <Navigation />
      <FloatingCTA />
      
      <main>
        <HeroSection />
        <ProductRevealSection />
        <CompactServicesSection />
        <AnalyticsSection />
        <AutomationSection />
        <PlatformSection />
        <AIAgentSection />
        <LiveBudgetsSection />
        <BuyBoxSection />
        <KeywordOptimizationSection />
        <EnhancedReportingSection />
        <CaseStudiesSection />
        <TestimonialsSection />
        <CTASection />
        <ContactSection />
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
